import React, { useEffect, useState, useCallback } from 'react';
import AntToolbar from './AntToolbar';
import AntLocalization from '../utils/AntLocalization';
import AntWidgetSkeleton, { AntWidgetEmpty } from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

var TYPE_COLORS = {
    success: '#3d7a6a',
    warning: '#b8860b',
    error: '#b34040',
    info: 'var(--AnteBaseColor1)',
    default: '#8b95a5'
};

export default function (props) {
    var [items, setItems] = useState([]);
    var [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url));

    var load = useCallback(async () => {
        if (props.url) {
            props.API.post(props.url, { ...props.searchConditions }, (resp) => {
                if (resp && !resp.error) {
                    if (resp.data instanceof Array) setItems(resp.data);
                    else if (resp.data && resp.data.items instanceof Array) setItems(resp.data.items);
                    else setItems([]);
                } else {
                    setItems([]);
                }
                markLoaded();
            });
        }
    }, [props.API, props.url, props.searchConditions, markLoaded]);

    useEffect(() => {
        load();
        var interval = setInterval(load, 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        load();
    }, [props.searchConditions, props.url]);

    useEffect(() => {
        if (props.dataSource && !props.url) setItems(props.dataSource);
    }, [props.dataSource]);

    var timeField = props.timeField || 'time';
    var titleField = props.titleField || 'title';
    var subtitleField = props.subtitleField || 'subtitle';
    var typeField = props.typeField || 'type';
    var maxItems = props.maxItems || 10;

    var displayItems = items.slice(0, maxItems);

    if (!loaded) {
        return (
            <React.Fragment>
                {props.title && <AntToolbar title={props.title} isH6={true} upperCase={true} />}
                <AntWidgetSkeleton variant="timeline" rows={Math.min(maxItems, 4)} height={props.height} />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            {props.title && <AntToolbar title={props.title} isH6={true} upperCase={true} />}
            <div className="ant-widget-timeline" style={props.height ? { maxHeight: props.height, overflowY: 'auto' } : undefined}>
                {displayItems.map((item, idx) => {
                    var type = item[typeField] || 'default';
                    var dotColor = TYPE_COLORS[type] || TYPE_COLORS.default;
                    var timeVal = item[timeField] || '';
                    var titleVal = item[titleField] || '';
                    var subtitleVal = item[subtitleField] || '';
                    if (typeof titleVal === 'object') titleVal = AntLocalization.translateText(titleVal);
                    if (typeof subtitleVal === 'object') subtitleVal = AntLocalization.translateText(subtitleVal);

                    return (
                        <div key={idx} className={'ant-widget-timeline__item' + (idx === displayItems.length - 1 ? ' ant-widget-timeline__item--last' : '')}>
                            <div className="ant-widget-timeline__time">{timeVal}</div>
                            <div className="ant-widget-timeline__rail">
                                <span className="ant-widget-timeline__dot" style={{ background: dotColor }} />
                                <span className="ant-widget-timeline__line" />
                            </div>
                            <div className="ant-widget-timeline__content">
                                <div className="ant-widget-timeline__title">{titleVal}</div>
                                {subtitleVal && <div className="ant-widget-timeline__subtitle">{subtitleVal}</div>}
                            </div>
                        </div>
                    );
                })}
                {displayItems.length === 0 && <AntWidgetEmpty />}
            </div>
        </React.Fragment>
    );
}
